import * as React from 'react';
import ErrorHandler from './ErrorHandler/ErrorHandler';
import Popup from './Popup/Popup';
import { connect } from 'react-redux';

import { RootState } from 'Redux/Reducers/_RootReducer';

const Loader = () => (
    <div className="loader">
        <div className="loader__inner" />
    </div>
);

export type ConnectedProps = {
    detailsPanelVisible?: any;
    vehicleListVisible?: any;
    sidebarMenuExpanded?: any;
    activePage?: any;
    loaderVisible?: any;
};

class DefaultPageWrapper extends React.PureComponent<ConnectedProps, any> {
    public render() {
        // console.log('PAGE WRAPPER', this.props);
        const { detailsPanelVisible, vehicleListVisible, sidebarMenuExpanded, activePage, loaderVisible} = this.props;
        let extraClasses: string = '';
        extraClasses += detailsPanelVisible ? ' detailsPanelVisible' : '';
        extraClasses += vehicleListVisible ? ' vehicleListVisible' : '';
        extraClasses += sidebarMenuExpanded ? ' sidebarMenuExpanded' : '';
        extraClasses += activePage ? ` page--${activePage.title.toLowerCase()}` : '';
        return (
                <>
                    <ErrorHandler />
                    <Popup />
                    <div className={`main ${extraClasses}`}>
                        {this.props.children}
                    </div>
                    {loaderVisible && <Loader />}
                </>
        );
    }
}

function mapStateToProps(state: RootState): ConnectedProps {
    return {
        detailsPanelVisible: state.viewManagementStore.detailsPanelVisible,
        vehicleListVisible: state.viewManagementStore.vehicleListVisible,
        sidebarMenuExpanded: state.viewManagementStore.sidebarMenuExpanded,
        activePage: state.viewManagementStore.activePage,
        loaderVisible: state.viewManagementStore.loaderVisible
    };
}
export default connect(
    mapStateToProps,
    null
)(DefaultPageWrapper);



// WEBPACK FOOTER //
// ./src/components/Layout/DefaultPageWrapper.tsx